import { createContext, useState, useEffect } from "react";
import axios from "axios";
import Loading from "../components/Loading";

export const SubscriptionContext = createContext();

export const SubscriptionProvider = ({ children }) => {
  const clubDetailsString = localStorage.getItem("club_details");

  const club_details = JSON.parse(clubDetailsString);

  const [subscriptions, setSubscriptions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const response = await axios.get(
          `/api/subscription/${club_details?.club_id}`
        );
        setSubscriptions(response.data[0]);
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch subscriptions", err);
        setLoading(false);
      }
    };

    fetchSubscriptions();
  }, []);

  return (
    loading ? <Loading /> : <SubscriptionContext.Provider value={{ subscriptions, loading }}>
      {children}
    </SubscriptionContext.Provider>  
  );
};
